// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_Yp","refLinkDesktop":"e_Zp","titleFont":"e__p"};